/**
 * @author xyguo
 * @description 新开业培训要求记录管理
 * @Date 2021/3/16
 */
import React from 'react';
import {connect} from 'dva';

import {framework_tool, component_tool, utils_tool} from '@/tool'
import { modelUtils } from '@/utils';
import { Spin, Icon } from 'antd'
let {WizContainer, WizReduxTemplate} = framework_tool;
let {WizBrowserExport, WizCard, WizTabs, WizSpin, WizCol, WizRow,WizModal,WizTable,WizButton,WizDivider,WizMenu,WizDropdown,WizForm} = component_tool;
let {checkStrLength, Session} = utils_tool;
import { WizTableForm } from '../../../common'


const getParamRecord = (history) => {
  let record = {}
  if (history.location && history.location.pathname === '/dealerNewPersonTrain/requirementPositionOrder/requirementPositionOrderInfoList') {
    if (history.location && history.location.record) {
      record = history.location.record
      Session.set('requirementPositionOrderDetail', record);
    } else{
      record = Session.get('requirementPositionOrderDetail');
    }
  }
  return record
}

class RequirementPositionOrderInfoList extends WizContainer {

  componentName = 'RequirementPositionOrderInfoList';

  constructor(props) {
    super(props);
    const {history} = props;
    let initialValue= getParamRecord(history)
    this.state = {
      data:[],
      batchAddVisable: false,
      value: undefined
    }
    this.initialValue = initialValue;
  }

  _componentDidMount() {
    this._getPositionSortInfoList();
  }

  _getPositionSortInfoList() {
    this.doActions([
      {
        path: 'requirementPositionOrderInfo/list',
        payload: {
          key: 'requirementPositionOrderInfo@list',
          apiParams: { positionSortId: this.initialValue.id }
        }
      },
    ]);
  }

  _exportInfo() {
    this.doActions([
      {
        path: 'requirementPositionOrderInfo/list',
        payload: {
          key: 'requirementPositionOrderInfo@export',
          apiParams: { positionSortId: this.initialValue.id }
        }
      },
    ]);
  }

  updateState(val,state){
    this.doActions([
      {
        path: 'requirementPositionOrderInfo/update',
        payload: {
          key: 'requirementPositionOrderInfo@update',
          apiParams: {id:val.id,state }
        }
      },
    ]);
  }

  updateSort(val,state){
    this.doActions([
      {
        path: 'requirementPositionOrderInfo/changeUpOrDown',
        payload: {
          key: 'requirementPositionOrderInfo@changeUpOrDown',
          apiParams: { id:val.id,upOrDown:state }
        }
      },
    ]);
  }

  batchAdd(){
    let ids = []
    if(this.state.value && this.state.value.length){
      this.state.value.forEach(element => {
        ids.push(element.id);
      });
    }else{
      wizNotice.warn("请选择岗位");
      return
    }
    this.doActions([
      {
        path: 'requirementPositionOrderInfo/batchAdd',
        payload: {
          key: 'requirementPositionOrderInfo@batchAdd',
          apiParams: {positionSortId: this.initialValue.id,positionIdList:ids }
        }
      },
    ]);
  }

  propsAndStateOnChange = {
    requirementPositionOrderInfoList: this._requirementPositionOrderInfoListOver.bind(this),
    requirementPositionOrderInfoUpdate : this._updateOver.bind(this),
    requirementPositionOrderInfoChangeUpOrDown : this._changeUpOrDownOver.bind(this),
    exportInfo: this._exportInfoOver.bind(this),
    batchAddInfo: this._batchAddInfoOver.bind(this)
  };

  _requirementPositionOrderInfoListOver(nextProps, nextState) {
    let o = nextProps.requirementPositionOrderInfoList;
    if (o['success']) {
      this.state.data = o.data;
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _updateOver(nextProps, nextState) {
    let o = nextProps.requirementPositionOrderInfoUpdate;
    if (o['success']) {
      this._getPositionSortInfoList();
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _changeUpOrDownOver(nextProps, nextState) {
    let o = nextProps.requirementPositionOrderInfoChangeUpOrDown;
    if (o['success']) {
      this._getPositionSortInfoList();
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _batchAddInfoOver(nextProps, nextState, key){
    let o = nextProps.batchAddInfo
    if (o['success']) {
      wizNotice.success(o['msg'])
      this.state.batchAddVisable=false
      this._getPositionSortInfoList();
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _exportInfoOver(nextProps, nextState, key) {
    let o = nextProps.exportInfo;
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '岗位',
        field: 'positionName',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '排序',
        field: 'sort',
        width: 80,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
    
      {
        headerName: '状态',
        field: 'stateStr',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      }
    ]
    
    if (o['success']) {
      let data = o['data']
      WizBrowserExport({
        title: '岗位展示排序详情',
        sheetName: '岗位展示排序详情',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '岗位展示排序详情.xlsx',
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _showTitle(record) {
    let content = <WizCard title={'经销商信息'} bodyStyle={{paddingLeft: 20, paddingBottom: 25, paddingTop: 25}}>
      <WizRow>
        <WizCol span={4} offset={2}>
          品牌: {record.orgName}
        </WizCol>
        <WizCol span={18}>
          站点类型: {record.dealerTypeCh}
        </WizCol>
      </WizRow>
    </WizCard>
    return content;
  }

  


  _getAction(val) {
    let action = [];
    let upState = false;
    let downState = false;
    if(val.sort==1){
      upState = true;
    }
    if(this.state.data && this.state.data.length && val.sort){
      let sortMaxNum = 0;
      this.state.data.forEach(e=>{
        if(e.sort>sortMaxNum && e.state==1){
          sortMaxNum=e.sort
        }
      })
      if(val.sort=== sortMaxNum){
        downState = true;
      }
    }
    if (val.state ===1) {//启用状态的
      action.push(<WizButton key={val.id+'close'} type="link" size={'small'} onClick={e => this.updateState(val,0)}>禁用</WizButton>)
      action.push(<WizButton key={val.id+'up'} disabled={upState} type="link" size={'small'} onClick={e => this.updateSort(val,1)}>向上</WizButton>)
      action.push(<WizButton key={val.id+'down'} disabled={downState} type="link" size={'small'} onClick={e => this.updateSort(val,2)}>向下</WizButton>)
    } else {//禁用状态多
      action.push(<WizButton key={val.id+'open'} type="link" size={'small'} onClick={e => this.updateState(val,1)}>启用</WizButton>)
    }
    return action;
  }

  setFileData(nextKeys, nextRows) {
    this.setState({
      value: nextKeys
    })
  }

  getModal() {
    let tableFormProps = {
      title: '选择学员',
      showModal:false,
      visible:false,
      showSelectValue: true,
      showSelect:true,
      selectType: 'checkbox',
      initRows: [],
      value: [],
      onSelectedRows: this.setFileData.bind(this)
    };
    const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1,belongOrgId:this.initialValue.orgId } })
    return {...tableFormProps,...positionConfig};
  }

  _render() {
    let { requirementPositionOrderInfoLoading } = this.props
    let record = this.initialValue;
    const columns = [
      { title: '岗位', dataIndex: 'positionName',  align:'center',key: 'positionName', width: 300},
      { title: '排序', dataIndex: 'sort',  align:'center',key: 'sort', width: 200 },
      { title: '状态', dataIndex: 'stateStr', align:'center', key: 'stateStr'},
      {
        title: '操作',
        fixed: 'right',
        key: 'action',
        align:'center',
        width: 400,
        render: (text, record) => (
          <span>
            {this._getAction(record)}
          </span>
        ),
      },
    ];

    let dataTableProps = {
      loading: false,
      columns,
      dataSource:this.state.data ,// data,
      rowKey: "id",
      showNum: false,
      isScroll: true,
      reasonable: true,
      pagination: false,
      bordered:true,
      scroll :{ x: 800, }
    };

    let modalInfo = {
      visible:this.state.batchAddVisable,
      width:1000,
      title:'新增岗位',
      onOk:()=>this.batchAdd(),
      onCancel:()=>this.setState({
        batchAddVisable:false
       })
    }
    
    return <Spin tip={'加载中'} spinning={requirementPositionOrderInfoLoading}> 
      {this._showTitle(record)}
      <WizCard title={'岗位展示顺序详情'}>
        <WizButton type='primary' style={{ marginLeft: 15, marginTop: 15, marginBottom: 15 }} onClick={e => this.setState({batchAddVisable:true})}>
                    新增
                  </WizButton>
        <WizButton type='export' style={{ marginLeft: 15, marginTop: 15, marginBottom: 15 }} onClick={e => this._exportInfo()}>
                    导出
                  </WizButton>
        <WizTable  {...dataTableProps}   />
        <WizModal  {...modalInfo}>
            <WizTableForm  {...this.getModal()} ></WizTableForm>
        </WizModal>
      </WizCard>
      </Spin>
  }
}

const mapStateToProps = (state, ownProps) => {
  const { requirementPositionOrderInfo } = state;
  const requirementPositionOrderInfoList = modelUtils.getModelEntity(requirementPositionOrderInfo, "requirementPositionOrderInfo@list");
  const exportInfo = modelUtils.getModelEntity(requirementPositionOrderInfo, "requirementPositionOrderInfo@export");
  const requirementPositionOrderInfoUpdate = modelUtils.getModelEntity(requirementPositionOrderInfo, "requirementPositionOrderInfo@update");
  const requirementPositionOrderInfoChangeUpOrDown = modelUtils.getModelEntity(requirementPositionOrderInfo, "requirementPositionOrderInfo@changeUpOrDown");
  const batchAddInfo = modelUtils.getModelEntity(requirementPositionOrderInfo, "requirementPositionOrderInfo@batchAdd");
  const load = modelUtils.getLoadingState(state, ['requirementPositionOrderInfo']);
  return {
    requirementPositionOrderInfoList,
    requirementPositionOrderInfoUpdate,
    requirementPositionOrderInfoChangeUpOrDown,
    exportInfo,
    batchAddInfo,
    ...load
  }
};

export default connect(mapStateToProps)(RequirementPositionOrderInfoList);
